export const actionType = {
  GET_FOOTER_MENUS:  'GET_FOOTER_MENUS',
  FOOTER_MENUS_RECEIVED:  'FOOTER_MENUS_RECEIVED',
}
export const getFooterMenus = () => ({
  type: actionType.GET_FOOTER_MENUS,
});
  
  